//@ts-nocheck
//@ts-ignore
import { FunctionComponent } from "react";
import { ConnectedProps, connect } from "react-redux";
import { RootState } from "../../../../stores/AppReducers";
import Logo from "../../assets/images/MarkLogoHorizontalWhite.png";
import FacebookLogo from "../../assets/images/facebook.png";
import InstagramLogo from "../../assets/images/instagram.png";
import TwitterLogo from "../../assets/images/twitter.png";
import UiActions from "../../stores/Ui/Actions";
import {
  CenterContainer,
  Container,
  LogoImage,
  SocialNetworkContainer,
} from "./styles/FooterStyles";

const Footer: FunctionComponent<ScreenProps> = (props) => {

  return (
    <Container>
      <CenterContainer>
        <LogoImage onClick={() => navigate("home")} src={Logo} />
        <p>Copyright © 2026 IQtek, Todos los derechos reservados.</p>
        <SocialNetworkContainer>
          <a href="https://www.facebook.com/fundacioniqtek/" target="_blank">
            <img src={FacebookLogo} />
          </a>
          <a href="https://x.com/fundacioniqtek1" target="_blank">
            <img src={TwitterLogo} />
          </a>
          <a href="https://www.instagram.com/fundacioniqtek/" target="_blank">
            <img src={InstagramLogo} />
          </a>
        </SocialNetworkContainer>
      </CenterContainer>
    </Container>
  );
};
interface ScreenProps extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  menuState: state.ui.menuState,
});

const mapDispatchToProps = {
  openMenu: UiActions.openMenu,
  closeMenu: UiActions.closeMenu,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(Footer);
